<app-rewards-grid
  #myComponent
  [config]="rewardsGridConfig"
  [title]="title"
  [rewardsService]="rewardService"
  (onExport)="onExport($event)"
  (onPayment)="onPayment($event)"
  (onAddReward)="onAddReward($event)"
  (onViewLedger)="onViewLedger($event)"
  (onDataChange)="onDataChange($event)"
  (onFilterChange)="onFilterChange($event)"
></app-rewards-grid>
